function initImageComparisons() {
	const comps = document.querySelectorAll(".image-comparison");
	if (!comps.length) return;

	comps.forEach((comp) => {
		const overlay = comp.querySelector(".img-comp-overlay");
		if (!overlay) return;

		// Build the slider bar
		const slider = document.createElement("div");
		slider.className = "img-comp-slider";
		slider.innerHTML =
			"<span class='circle'><i class='fas fa-chevron-left'></i><i class='fas fa-chevron-right'></i></span>";
		comp.insertBefore(slider, comp.firstChild);

		let dragging = false;
		let percentage = 0.5;

		function clamp(val, min, max) {
			return Math.max(min, Math.min(val, max));
		}

		function setPositionByX(x) {
			const w = comp.clientWidth || 0;
			x = clamp(x, 0, w);
			percentage = w ? x / w : 0.5;
			overlay.style.clipPath = `inset(0 ${w - x}px 0 0)`;
			overlay.style.webkitClipPath = `inset(0 ${w - x}px 0 0)`;
			slider.style.left = x - slider.offsetWidth / 2 + "px";
		}

		function setPositionBypercentage(p) {
			const w = comp.clientWidth || 0;
			setPositionByX(p * w);
		}

		function getXFromEvent(e) {
			const rect = comp.getBoundingClientRect();
			const clientX =
				e.touches && e.touches[0] ? e.touches[0].clientX : e.clientX;
			return clientX - rect.left - window.pageXOffset;
		}

		function onDown(e) {
			e.preventDefault();
			dragging = true;
			document.addEventListener("mousemove", onMove);
			document.addEventListener("touchmove", onMove, { passive: false });
		}

		function onUp() {
			dragging = false;
			document.removeEventListener("mousemove", onMove);
			document.removeEventListener("touchmove", onMove);
		}

		function onMove(e) {
			if (!dragging) return;
			e.preventDefault();
			setPositionByX(getXFromEvent(e));
		}

		// Start centered
		setPositionBypercentage(percentage);

		// Events
		slider.addEventListener("mousedown", onDown);
		document.addEventListener("mouseup", onUp);
		slider.addEventListener("touchstart", onDown, { passive: false });
		document.addEventListener("touchend", onUp);

		// Keep position on resize
		window.addEventListener("resize", () =>
			setPositionBypercentage(percentage)
		);
	});
}

document.addEventListener("DOMContentLoaded", initImageComparisons);
